import { CognitoUserPool, CognitoUser, AuthenticationDetails } from 'amazon-cognito-identity-js';
import { config } from '../config';

const userPool = new CognitoUserPool({
  UserPoolId: config.cognito.userPoolId,
  ClientId: config.cognito.userPoolWebClientId
});

export const authService = {
  signIn: (username, password) => {
    return new Promise((resolve, reject) => {
      const user = new CognitoUser({
        Username: username,
        Pool: userPool
      });

      const authDetails = new AuthenticationDetails({
        Username: username,
        Password: password
      });

      user.authenticateUser(authDetails, {
        onSuccess: (result) => {
          resolve({
            idToken: result.getIdToken().getJwtToken(),
            accessToken: result.getAccessToken().getJwtToken(),
            refreshToken: result.getRefreshToken().getToken()
          });
        },
        onFailure: (err) => {
          reject(err);
        }
      });
    });
  },

  signOut: () => {
    const user = userPool.getCurrentUser();
    if (user) {
      user.signOut();
    }
  },

  getCurrentUser: () => {
    return new Promise((resolve, reject) => {
      const user = userPool.getCurrentUser();

      if (!user) {
        resolve(null);
        return;
      }

      user.getSession((err, session) => {
        if (err) {
          reject(err);
          return;
        }

        if (!session.isValid()) {
          resolve(null);
          return;
        }

        resolve({
          user,
          idToken: session.getIdToken().getJwtToken(),
          accessToken: session.getAccessToken().getJwtToken()
        });
      });
    });
  },

  getIdToken: () => {
    return new Promise((resolve, reject) => {
      const user = userPool.getCurrentUser();

      if (!user) {
        resolve(null);
        return;
      }

      user.getSession((err, session) => {
        if (err) {
          reject(err);
          return;
        }

        resolve(session.getIdToken().getJwtToken());
      });
    });
  }
};